/**
 * AmenityDiff Component
 * Displays amenity changes as colored chips for added/removed items.
 */

import { Badge } from '@/components/ui/badge';

interface AmenityDiffProps {
  /** Removed amenities */
  removed: string[];
  /** Added amenities */
  added: string[];
}

export function AmenityDiff({ removed, added }: AmenityDiffProps): JSX.Element {
  const hasRemoved = removed.length > 0;
  const hasAdded = added.length > 0;

  if (!hasRemoved && !hasAdded) {
    return (
      <div className="text-sm text-muted-foreground py-2">
        No amenity changes
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-2 py-2" data-testid="amenity-diff">
      {removed.map((amenity, index) => (
        <Badge
          key={`removed-${String(index)}`}
          variant="outline"
          className="border-red-300 bg-red-50 text-red-700"
          data-testid="amenity-diff-removed"
        >
          -{amenity}
        </Badge>
      ))}
      {added.map((amenity, index) => (
        <Badge
          key={`added-${String(index)}`}
          variant="outline"
          className="border-green-300 bg-green-50 text-green-700"
          data-testid="amenity-diff-added"
        >
          +{amenity}
        </Badge>
      ))}
    </div>
  );
}
